import { RowWrapper } from "./RowWrapper";
import { Stack } from "@mui/material";

const Item = ({
  minWidth,
  maxWidth,
  justifyContent = "flex-start",
  itemMaxWidth = "100%",
}: {
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  itemMaxWidth?: string;
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      padding="0 16px"
    >
      <span
        style={{
          borderRadius: "8px",
          height: "16px",
          width: "100%",
          maxWidth: itemMaxWidth,
          backgroundColor: "#ECECEC",
        }}
      ></span>
    </Stack>
  );
};

export const EmptyRow = () => {
  return (
    <RowWrapper isHighlighted={false}>
      <Item minWidth={"120px"} maxWidth={"16%"} />
      <Item minWidth={"100px"} maxWidth={"18%"} />
      <Item minWidth={"100px"} maxWidth={"18%"} itemMaxWidth={"72px"} />
      <Item minWidth={"164px"} maxWidth={"14%"} itemMaxWidth={"100px"} />
      <Item
        minWidth={"162px"}
        maxWidth={"12%"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
      <Item
        minWidth={"148px"}
        maxWidth={"12%"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
      <Item
        minWidth={"124px"}
        maxWidth={"10%"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
    </RowWrapper>
  );
};
